import { render, staticRenderFns } from "./PerkPreviewCard.vue?vue&type=template&id=17f81c58&scoped=true&"
import script from "./PerkPreviewCard.vue?vue&type=script&lang=js&"
export * from "./PerkPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PerkPreviewCard.vue?vue&type=style&index=0&id=17f81c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f81c58",
  null
  
)

export default component.exports